import brandPortalMessages from "@faire/web-api/routes/brand-portal/messages";
import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../../common/Bold";
import { LiItem } from "../../common/LiItem";
export var SWFProcessing = function SWFProcessing() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "UQwnVh",
    defaultMessage: [{
      "type": 0,
      "value": "Als je wijzigingen moet aanbrengen in je bestelling of in de verzendinformatie nadat je je etiketten al hebt gemaakt via Verzenden met Faire, kun je best het oorspronkelijke verzendetiket annuleren en een nieuwe aanmaken."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gUUgvI",
    defaultMessage: [{
      "type": 0,
      "value": "Om het etiket te annuleren:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Ig/mCO",
    defaultMessage: [{
      "type": 0,
      "value": "Ga naar het gedeelte "
    }, {
      "children": [{
        "type": 0,
        "value": "Verzendinformatie"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " van de "
    }, {
      "children": [{
        "type": 0,
        "value": "pagina met bestelgegevens"
      }],
      "type": 8,
      "value": "OrderLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      OrderLinkFormatting: function OrderLinkFormatting(chunks) {
        return _OrderLinkFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xWq8Sw",
    defaultMessage: [{
      "type": 0,
      "value": "Selecteer "
    }, {
      "children": [{
        "type": 0,
        "value": "Annuleren"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xlrvao",
    defaultMessage: [{
      "type": 0,
      "value": "Nieuwe etiketten aanmaken en afdrukken via "
    }, {
      "children": [{
        "type": 0,
        "value": "Verzenden met Faire"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". Om fouten te voorkomen, raden we je aan om de hoeveelheden en verzendgegevens te controleren voordat je je etiket aanmaakt."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "i0uRyq",
    defaultMessage: [{
      "type": 0,
      "value": "We raden je ook aan om je retailer op de hoogte te stellen van de wijzigingen in de verzendgegevens via "
    }, {
      "children": [{
        "type": 0,
        "value": "Faire Messenger"
      }],
      "type": 8,
      "value": "ButtonFormatting"
    }, {
      "type": 0,
      "value": " om verwarring te voorkomen."
    }],
    values: {
      ButtonFormatting: function ButtonFormatting(chunks) {
        return FaireMessagingFormatting(chunks);
      }
    }
  })));
};
var FaireMessagingFormatting = function FaireMessagingFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalMessages(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};